/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { LogoWhatsappIcon16Light } from './LogoWhatsappIcon16Light';
import { LogoWhatsappIcon16Regular } from './LogoWhatsappIcon16Regular';
import { LogoWhatsappIcon16Solid } from './LogoWhatsappIcon16Solid';
import { LogoWhatsappIcon20Light } from './LogoWhatsappIcon20Light';
import { LogoWhatsappIcon20Regular } from './LogoWhatsappIcon20Regular';
import { LogoWhatsappIcon20Solid } from './LogoWhatsappIcon20Solid';
import { LogoWhatsappIcon24Regular } from './LogoWhatsappIcon24Regular';
import { LogoWhatsappIcon24Solid } from './LogoWhatsappIcon24Solid';
import { LogoWhatsappIcon32Regular } from './LogoWhatsappIcon32Regular';
import { LogoWhatsappIcon64Regular } from './LogoWhatsappIcon64Regular';
var sizes = {
    16: {
        light: LogoWhatsappIcon16Light,
        regular: LogoWhatsappIcon16Regular,
        solid: LogoWhatsappIcon16Solid,
    },
    20: {
        light: LogoWhatsappIcon20Light,
        regular: LogoWhatsappIcon20Regular,
        solid: LogoWhatsappIcon20Solid,
    },
    24: {
        regular: LogoWhatsappIcon24Regular,
        solid: LogoWhatsappIcon24Solid,
    },
    32: {
        regular: LogoWhatsappIcon32Regular,
    },
    64: {
        regular: LogoWhatsappIcon64Regular,
    },
};
export var LogoWhatsappIcon = forwardRef('LogoWhatsappIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
